import React from "react";
import {
  Box,
  Typography,
  CardContent,
  LinearProgress,
  Divider,
} from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { PurchaseOrderStatsDto } from "../../../shared/dtos/purchaseOrder/PurchaseOrderStatsDto";

interface PurchaseOrderWidgetProps {
  data: PurchaseOrderStatsDto;
}

const PurchaseOrderWidget: React.FC<PurchaseOrderWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("PURCHASE_ORDER");
  const Icon = meta.icon;

  const safeTotal = data.orderAmountToday || 1;
  const paidPercentage = (data.paidAmountToday / safeTotal) * 100;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Order Value
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {formatCurrency(data.orderAmountToday)}
          </Typography>
        </Box>

        <Box>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography variant="body2" sx={{ color: "success.main" }}>
              Paid
            </Typography>
            <Typography variant="body2">
              {formatCurrency(data.paidAmountToday)}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={paidPercentage}
            color="success"
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Orders Placed
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {data.ordersToday}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default PurchaseOrderWidget;
